import "./../login/login.css";
import "./splash.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "./../../assets/HiFi-Red.svg";
import { TailSpin } from "react-loader-spinner";
import axios from "../../network/api";
import { baseUrl } from "../../network/constants/constants";
import AppConstants from "../AppConstants";

function Splash({ fcmToken, isLoading }) {
  const navigate = useNavigate();
  const [fcmSaved, setFcmSaved] = useState(false);

  useEffect(() => {
    // Don't proceed if still loading
    if (isLoading) return;

    const authToken = localStorage.getItem(AppConstants.JWT);
    
    // If no auth token, clear storage and go to login
    if (!authToken) {
      localStorage.removeItem(AppConstants.JWT);
      localStorage.removeItem(AppConstants.FCM);
      navigate("/login", { replace: true });
      return;
    }

    // If user is authenticated but no FCM token yet, wait
    if (!fcmToken) {
      console.log("Waiting for FCM token...");
      return;
    }

    // If FCM token exists and hasn't been saved yet, save it
    if (fcmToken && !fcmSaved) {
      console.log("Saving FCM token:", fcmToken);
      
      axios
        .post(
          baseUrl + "auth/fcm/save/",
          { token: fcmToken, device_type: "web" },
          { 
            headers: { 
              Authorization: `Token ${authToken}`, 
              "Content-Type": "application/json" 
            } 
          }
        )
        .then((res) => {
          console.log("FCM saved successfully:", res.data);
          setFcmSaved(true);
          // Navigate to home since user is already authenticated
          navigate("/home", { replace: true });
        })
        .catch((err) => {
          console.error("Error saving FCM:", err.response?.data || err.message);
          // Even if FCM save fails, navigate to home if user is authenticated
          navigate("/home", { replace: true });
        });
    }
  }, [fcmToken, isLoading, navigate, fcmSaved]);

  return (
    <section id="login">
      <div className="content">
        <div className="brand-container">
          <img alt="logo" src={Logo} className="logo" />
          <TailSpin
            className="splash-spinner"
            height="30"
            width="30"
            radius="1"
            color="#ff4d4d"
            ariaLabel="loading"
            visible={true}
          />
        </div>
      </div>
      <a href="tel:+919481815122" className="contact">
        ⓘ Contact Us
      </a>
    </section>
  );
}

export default Splash;